import React from "react";

export default function SatuSehat({
  fill = "#110F0D",
  background= "transparent",
  width = "86",
  height = "46",
  clicked = false,
}) {
  return (
    <svg
      width={width} //86
      height={height} // 46
      viewBox={`0 0 368 368`}
      enable-background="new 0 0 368 368"
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ pointerEvents: clicked ? 'none' : '' }}>
     {/* <path fill={background} opacity="1.000000" stroke="none" 
	d="
M653.000000,369.000000 
	C435.372009,369.000000 218.244049,369.000000 1.058035,369.000000 
	C1.058035,246.393906 1.058035,123.787766 1.058035,1.090816 
	C345.544708,1.090816 690.089417,1.090816 1034.817139,1.090816 
	C1034.817139,123.666451 1034.817139,246.333191 1034.817139,369.000000 
	C907.787659,369.000000 780.643860,369.000000 653.000000,369.000000 
M101.034035,102.108147 
	C89.327942,102.072029 77.621628,101.985779 65.915939,102.038757 
	C63.330994,102.050453 60.748276,102.555084 57.259026,102.989296 
	C54.607052,103.104881 51.834705,102.756851 49.322113,103.409241 
	C28.834024,108.728882 15.003813,128.153107 18.967665,149.912842 
	C22.210541,167.714767 38.828815,181.991028 57.009853,181.996368 
	C96.482071,182.007950 135.954300,181.999954 175.426514,181.999954 
	C177.504135,181.999954 179.581772,181.999939 182.000046,181.999939 
	C182.000046,178.955612 182.000046,176.806213 182.000046,174.656815 
	C182.000031,135.351151 182.023987,96.045425 181.953979,56.739887 
	C181.948456,53.638901 181.604675,50.463722 180.883728,47.450897 
	C176.060898,27.296198 154.089966,14.259101 133.909225,18.720726 
	C116.594894,22.548630 102.889313,37.663239 102.536713,57.790623 
	C102.443649,72.498642 102.350594,87.206665 102.154060,102.115631 
	C102.154060,102.115631 101.957741,102.227623 101.034035,102.108147 
M102.043991,273.066711 
	C102.029457,283.222198 101.928825,293.378632 102.040054,303.532745 
	C102.088913,307.993439 102.569382,312.449463 102.935402,317.795685 
	C103.398262,332.572479 110.732651,343.169952 123.128906,350.525299 
	C135.632492,357.944336 148.585419,357.886475 161.078644,351.009674 
	C173.809494,344.002136 181.828247,333.171661 181.917694,318.149872 
	C182.154800,278.331818 182.004395,238.511368 181.993088,198.691864 
	C181.991196,192.047623 181.956223,192.009735 175.399704,192.007645 
	C135.746811,191.994965 96.093208,191.856705 56.441296,192.053619 
	C31.675793,192.176620 13.650051,215.418640 18.599812,239.904434 
	C22.125248,257.344269 37.971035,271.642548 57.785606,271.560394 
	C59.763191,271.706726 61.740005,271.967468 63.718491,271.980804 
	C76.501778,272.066986 89.285431,272.099213 102.043991,273.066711 
M271.954987,102.045319 
	C271.954987,102.045319 272.053040,102.044792 272.025757,101.098625 
	C272.016754,87.861137 272.046844,74.623398 271.958496,61.386440 
	C271.944550,59.297810 271.395233,57.212753 270.995209,54.250706 
	C270.639221,51.634663 270.574677,48.938416 269.880371,46.415489 
	C265.074951,28.954187 248.270157,17.427191 230.688354,17.824402 
	C210.273773,18.285610 192.000641,35.868992 192.001480,56.207561 
	C192.003082,95.852074 191.996155,135.496582 192.005905,175.141098 
	C192.007584,181.964554 192.037567,181.992737 198.930481,181.994446 
	C238.241837,182.004196 277.553314,181.940414 316.864502,182.023560 
	C337.676025,182.067581 355.426849,164.558014 355.908295,143.347595 
	C356.394318,121.937386 339.309418,102.699028 316.214386,102.439598 
	C301.461060,102.275475 286.707703,102.111359 271.954987,102.045319 
M272.901398,272.025726 
	C285.472900,272.016754 298.044708,272.048706 310.615601,271.958405 
	C312.703674,271.943420 314.787933,271.395233 317.768646,270.996857 
	C320.084717,270.842316 322.473938,271.002716 324.705383,270.484100 
	C344.875244,265.796082 359.208221,245.653320 355.119598,224.350342 
	C351.615997,206.095444 335.548798,192.020340 316.956360,192.008224 
	C277.816162,191.982727 238.675964,191.997101 199.535767,192.002930 
	C192.016602,192.004044 192.003235,192.020630 192.002243,199.751160 
	C191.997223,238.391693 192.466721,277.040131 191.812424,315.669586 
	C191.459106,336.529602 210.234207,356.666382 232.592255,356.256470 
	C252.204697,355.896851 271.377014,338.663818 271.560425,318.214325 
	C271.706451,316.403534 271.972321,314.593231 271.979401,312.781921 
	C272.032532,299.172852 272.034668,285.563568 271.954651,271.954987 
	C271.954651,271.954987 271.955200,272.053040 272.901398,272.025726 
M997.595032,167.796844 
	C997.757080,167.589172 997.906616,167.372833 998.965942,167.056015 
	C1002.130005,167.036041 1005.294250,167.031754 1008.458069,166.992859 
	C1015.159546,166.910492 1018.040283,164.101273 1017.990051,157.725449 
	C1017.942871,151.735138 1015.050232,149.035126 1008.436829,149.016235 
	C994.447388,148.976273 980.457703,148.974045 966.468323,149.017944 
	C959.949829,149.038406 956.841248,151.887054 956.786621,157.673782 
	C956.728088,163.867462 959.858826,166.898010 966.433960,166.992035 
	C968.265564,167.018219 970.115784,167.167419 971.926147,166.971130 
	C975.845032,166.546234 977.111511,168.140442 977.067566,172.064133 
	C976.890442,187.883652 976.979919,203.706390 977.022461,219.527817 
	C977.027832,221.506653 977.140503,223.526611 977.545959,225.455536 
	C979.012329,232.432678 982.045898,234.603455 989.161255,234.000153 
	C994.541443,233.544006 996.646301,230.918869 997.322571,223.795624 
	C997.449646,223.512970 997.451538,223.229095 997.298950,222.014420 
	C997.307861,204.038132 997.316772,186.061859 997.595032,167.796844 
M790.808472,234.051178 
	C796.609497,233.204102 799.996277,229.680389 799.779541,224.717392 
	C799.548767,219.429535 795.713074,216.092957 789.704529,216.012741 
	C786.376526,215.968307 783.046204,216.059296 779.718994,215.990082 
	C767.375793,215.733322 769.296692,218.057938 768.943359,205.108780 
	C768.838196,201.255798 770.035645,199.840973 774.023071,199.908844 
	C779.464050,200.001434 785.033936,199.995651 790.332275,198.943283 
	C795.950928,197.827286 797.893127,193.783417 796.940125,187.933212 
	C796.347839,184.297424 792.283569,181.183487 787.740295,181.033539 
	C784.581360,180.929306 781.415161,181.064194 778.254639,180.988800 
	C768.190979,180.748718 769.111877,183.034622 768.961792,171.141403 
	C768.918640,167.720734 770.439270,166.886337 773.488831,166.970230 
	C778.644165,167.112076 783.806885,167.041870 788.965637,166.983826 
	C794.935547,166.916656 798.836975,163.464645 798.969177,158.237274 
	C799.108337,152.733978 795.197876,149.057083 788.969666,149.020523 
	C779.150574,148.962875 769.330688,148.969498 759.511536,149.016342 
	C752.804871,149.048340 749.080078,152.637192 749.047852,159.530121 
	C748.948181,180.832794 748.953857,202.136475 749.045105,223.439209 
	C749.073547,230.082214 752.249939,233.301636 759.204346,234.322617 
	C759.204346,234.322617 759.629272,234.419357 759.629272,234.419357 
	C759.629272,234.419357 760.056030,234.328476 760.985535,234.299026 
	C770.305115,234.308975 779.624756,234.318939 789.224243,234.419815 
	C789.531128,234.443863 789.801453,234.354324 790.808472,234.051178 
M71.191673,94.921097 
	C88.004234,89.395004 100.502731,69.763313 97.214233,51.070198 
	C94.100510,33.370510 76.859718,17.910063 58.070995,17.680119 
	C36.129189,17.411589 14.785009,39.094044 18.830381,63.742386 
	C22.603350,86.730988 46.801723,103.268036 71.191673,94.921097 
M804.732910,176.500031 
	C804.754150,192.319595 804.633057,208.141174 804.856079,223.957886 
	C804.969727,232.017715 809.344910,235.293793 817.248657,233.930466 
	C822.103882,233.092987 824.760925,229.192352 824.954529,222.104767 
	C825.118164,216.114090 825.098755,210.114059 824.977966,204.121841 
	C824.918518,201.172272 825.952515,199.933441 829.016663,199.975128 
	C838.007263,200.097519 847.001709,200.098007 855.992310,199.975128 
	C859.064758,199.933151 860.073914,201.190689 860.022766,204.130310 
	C859.906799,210.789124 859.934204,217.452469 860.025513,224.112289 
	C860.113159,230.500076 863.664673,233.970688 869.919983,233.990967 
	C876.257629,234.011520 879.942200,230.604858 879.963379,224.272522 
	C880.036316,202.457993 880.032043,180.642944 879.967285,158.828369 
	C879.948608,152.524002 876.226318,149.006409 869.989502,149.009079 
	C863.757690,149.011749 860.125488,152.531540 860.025208,158.849609 
	C859.935425,164.510101 859.829407,170.179749 860.054260,175.832489 
	C860.204224,179.602875 859.114685,181.209610 855.027954,181.075424 
	C846.710693,180.802307 838.373169,180.823654 830.054138,181.068451 
	C826.103943,181.184692 824.904663,179.805161 824.912659,175.916840 
	C824.926575,169.127411 824.831421,162.270187 823.884949,155.568024 
	C823.145020,150.327805 819.325989,148.547470 812.788818,149.021698 
	C808.044922,149.365845 805.301453,151.937210 805.034180,157.028152 
	C804.711426,163.173798 804.814087,169.341797 804.732910,176.500031 
M669.931885,221.336243 
	C675.033020,214.179550 677.169312,206.203262 677.044312,197.430542 
	C676.868591,185.102509 677.013489,172.770096 676.993530,160.439621 
	C676.981018,152.684982 673.795288,149.035889 667.091248,149.009048 
	C660.150513,148.981262 657.020752,152.417664 657.006836,160.173050 
	C656.983765,173.003403 657.095703,185.834900 656.959656,198.663895 
	C656.853821,208.648315 649.750793,215.148376 639.477112,214.992661 
	C628.952759,214.833160 623.018555,208.939651 623.004761,198.595108 
	C622.989685,187.264374 623.085571,175.932602 622.947937,164.603516 
	C622.907959,161.311539 622.560486,157.945282 621.762512,154.761322 
	C620.872803,151.211838 618.173950,149.340927 614.449890,149.021942 
	C606.379883,148.330704 602.920654,151.135635 602.841125,159.362701 
	C602.701050,173.854263 602.806702,188.351227 603.040527,202.842194 
	C603.177979,211.358109 606.891968,218.294022 612.694275,224.553391 
	C624.651428,237.452499 656.744751,238.297119 669.931885,221.336243 
M903.495911,170.991547 
	C901.831055,175.331207 900.132629,179.658325 898.507751,184.012894 
	C893.812012,196.597076 888.945496,209.123047 884.559998,221.814926 
	C882.618835,227.432632 884.764954,231.952698 889.043579,233.573486 
	C894.666138,235.703400 900.398010,233.499191 902.835999,228.155670 
	C903.728271,226.199783 904.497986,224.159348 905.053284,222.085114 
	C905.847046,219.119843 907.365051,217.818130 910.660339,217.927643 
	C918.147888,218.176483 925.657593,218.212189 933.141602,217.914444 
	C936.706665,217.772583 938.075928,219.270355 939.057617,222.364761 
	C940.000305,225.336426 941.236084,228.335617 942.956543,230.913193 
	C945.893555,235.313385 950.628357,234.568787 954.744385,233.522400 
	C958.459473,232.577957 960.315186,229.424286 959.957275,225.424561 
	C959.781250,223.457092 959.600098,221.404388 958.913574,219.581436 
	C951.254089,199.242813 943.685669,178.865707 935.637878,158.680359 
	C933.460510,153.219147 929.583984,149.021423 922.548035,148.883499 
	C915.376099,148.742889 911.458069,152.555939 908.743042,158.327255 
	C906.910828,162.222198 905.453369,166.293442 903.495911,170.991547 
M540.789978,232.541199 
	C543.997375,229.871170 544.699036,226.481857 543.463318,222.651840 
	C542.039490,218.238770 540.629578,213.812469 538.966736,209.486816 
	C532.362244,192.306046 525.816345,175.099548 518.906555,158.041183 
	C516.695679,152.583115 512.790771,148.914993 506.014587,148.878998 
	C499.127594,148.842422 495.060028,152.201447 492.563843,157.989761 
	C489.738953,164.540283 487.136963,171.191711 484.603119,177.861969 
	C479.240601,191.978699 473.833618,206.081985 468.753601,220.301071 
	C466.408173,226.865952 467.953827,231.268082 472.376648,233.269577 
	C477.972961,235.802109 483.478149,233.975586 486.324219,228.468063 
	C487.382874,226.419464 488.316498,224.230148 488.832672,221.995422 
	C489.580780,218.756653 491.462128,217.870819 494.560364,217.957001 
	C500.553162,218.123718 506.553955,218.000519 512.551453,218.000427 
	C521.032043,218.000290 521.032043,218.001434 524.028870,225.804703 
	C527.180115,234.009995 531.565491,235.955215 540.789978,232.541199 
M696.953674,194.648438 
	C703.228699,196.744324 709.519226,198.795197 715.772522,200.953888 
	C719.233582,202.148666 721.685486,204.311417 720.870789,208.362976 
	C720.052673,212.431549 717.058838,214.382233 713.193359,213.893829 
	C707.170837,213.132889 701.158203,212.030212 695.266479,210.568329 
	C688.707153,208.940796 684.308228,210.186371 682.090454,215.040863 
	C679.605957,220.479080 680.969421,225.101837 686.770935,228.520218 
	C698.635803,235.511292 711.436584,235.754776 724.269531,232.204086 
	C737.624939,228.508850 742.917480,218.044678 742.805115,207.476883 
	C742.684631,196.151123 738.553467,188.838089 723.748779,183.983871 
	C719.179993,182.485855 714.571411,181.099945 710.048462,179.474945 
	C707.095886,178.414154 703.532959,177.309341 704.257690,173.203522 
	C704.942505,169.323456 708.341919,167.874329 711.809937,168.138062 
	C715.880676,168.447647 719.932495,169.453552 723.906677,170.487534 
	C731.050476,172.346146 736.621643,169.556519 737.833313,163.256516 
	C738.620789,159.162094 735.804260,153.944565 730.545044,151.967484 
	C717.138123,146.927444 703.807007,146.913666 691.569580,155.257050 
	C684.376709,160.161057 681.783447,167.980698 682.326538,176.216904 
	C682.900208,184.916794 687.368469,191.553955 696.953674,194.648438 
M405.685089,224.572403 
	C407.504333,226.228073 409.054169,228.481461 411.186523,229.442535 
	C425.177460,235.748657 439.568939,236.815552 453.397919,229.632172 
	C468.351318,221.864777 470.751648,200.073929 457.799957,189.661560 
	C453.206879,185.968979 446.882782,184.368896 441.250336,182.053345 
	C438.041962,180.734329 434.448914,180.264542 431.387451,178.707687 
	C429.594513,177.795929 427.380371,175.475739 427.413757,173.830902 
	C427.447968,172.145233 429.795685,170.251968 431.510406,168.949173 
	C432.561676,168.150421 434.396820,167.865204 435.757446,168.090210 
	C439.650391,168.733994 443.494965,169.698502 447.332397,170.643066 
	C452.810120,171.991394 457.342072,170.681824 459.681915,166.791580 
	C462.031128,162.885681 461.470825,158.873856 458.695007,155.649780 
	C456.946930,153.619400 454.292938,151.962601 451.723236,151.117325 
	C441.326477,147.697388 430.799530,147.616913 420.607147,151.844025 
	C409.846832,156.306656 405.450104,164.400528 406.004730,177.533401 
	C406.355469,185.837402 411.813446,191.790298 422.313568,195.339981 
	C427.806854,197.197037 433.293488,199.073593 438.784515,200.937286 
	C442.814728,202.305161 444.923126,204.950470 443.812012,209.282547 
	C442.796722,213.241165 439.539398,214.416672 436.033600,213.907578 
	C430.020813,213.034454 424.127533,211.207520 418.101685,210.604935 
	C414.603760,210.255142 410.168549,210.430527 407.549255,212.311218 
	C404.026672,214.840485 402.661072,219.384537 405.685089,224.572403 
M561.000000,213.486450 
	C561.001587,216.648209 560.964783,219.810532 561.012573,222.971588 
	C561.125366,230.439896 564.614319,234.166275 571.360718,234.084869 
	C577.751282,234.007751 580.983582,230.292282 580.992554,222.904572 
	C581.012756,206.263809 581.179077,189.619965 580.892334,172.984146 
	C580.807434,168.060455 582.423828,166.386032 587.146606,166.950638 
	C589.441040,167.224915 591.815308,167.131226 594.125366,166.910400 
	C598.578369,166.484726 602.163452,162.451614 602.099548,158.191864 
	C602.023743,153.143326 598.769409,149.113388 594.154602,149.074646 
	C578.846375,148.946152 563.535278,148.932297 548.227661,149.095520 
	C543.627380,149.144562 540.113281,153.131943 540.042847,157.543030 
	C539.963196,162.528595 543.553467,166.626938 548.441833,166.944504 
	C550.928101,167.106003 553.450317,167.189285 555.924072,166.960281 
	C559.834656,166.598221 561.125610,168.124680 561.069153,172.055313 
	C560.875610,185.531525 560.997986,199.012283 561.000000,213.486450 
z"/> */}
<path fill="#3CAFA2" opacity="1.000000" stroke="none" 
	d="
M316.873962,102.906555 
	C339.309418,102.699028 356.394318,121.937386 355.908295,143.347595 
	C355.426849,164.558014 337.676025,182.067581 316.864502,182.023560 
	C277.553314,181.940414 238.241837,182.004196 198.930481,181.994446 
	C192.037567,181.992737 192.007584,181.964554 192.005905,175.141098 
	C191.996155,135.496582 192.003082,95.852074 192.001480,56.207561 
	C192.000641,35.868992 210.273773,18.285610 230.688354,17.824402 
	C248.270157,17.427191 265.074951,28.954187 269.880371,46.415489 
	C270.574677,48.938416 270.639221,51.634663 271.023010,55.145329 
	C271.036530,69.276604 270.976379,82.513535 271.054962,95.749626 
	C271.067413,97.849922 271.704651,99.946495 272.053040,102.044792 
	C272.053040,102.044792 271.954987,102.045319 272.332642,102.175537 
	C274.341583,102.532303 275.972443,102.951431 277.604187,102.954941 
	C290.694000,102.983124 303.784027,102.932838 316.873962,102.906555 
z"/>
<path fill="#3CAFA2" opacity="1.000000" stroke="none" 
	d="
M271.093445,318.873932 
	C271.377014,338.663818 252.204697,355.896851 232.592255,356.256470 
	C210.234207,356.666382 191.459106,336.529602 191.812424,315.669586 
	C192.466721,277.040131 191.997223,238.391693 192.002243,199.751160 
	C192.003235,192.020630 192.016602,192.004044 199.535767,192.002930 
	C238.675964,191.997101 277.816162,191.982727 316.956360,192.008224 
	C335.548798,192.020340 351.615997,206.095444 355.119598,224.350342 
	C359.208221,245.653320 344.875244,265.796082 324.705383,270.484100 
	C322.473938,271.002716 320.084717,270.842316 316.864319,271.023834 
	C303.389343,271.036469 290.818329,270.974091 278.248260,271.055023 
	C276.148499,271.068542 274.052795,271.704651 271.955200,272.053040 
	C271.955200,272.053040 271.954651,271.954987 271.824432,272.332642 
	C271.467651,274.342010 271.048096,275.973328 271.044922,277.605438 
	C271.017975,291.361542 271.067169,305.117737 271.093445,318.873932 
z"/>
<path fill="#3CAFA2" opacity="1.000000" stroke="none" 
	d="
M57.126038,271.093445 
	C37.971035,271.642548 22.125248,257.344269 18.599812,239.904434 
	C13.650051,215.418640 31.675793,192.176620 56.441296,192.053619 
	C96.093208,191.856705 135.746811,191.994965 175.399704,192.007645 
	C181.956223,192.009735 181.991196,192.047623 181.993088,198.691864 
	C182.004395,238.511368 182.154800,278.331818 181.917694,318.149872 
	C181.828247,333.171661 173.809494,344.002136 161.078644,351.009674 
	C148.585419,357.886475 135.632492,357.944336 123.128906,350.525299 
	C110.732651,343.169952 103.398262,332.572479 102.943985,316.890930 
	C102.929199,301.339294 102.905823,286.692413 102.519279,271.864349 
	C100.529785,271.459534 98.903839,271.045532 97.277077,271.042358 
	C83.893486,271.016235 70.509735,271.066437 57.126038,271.093445 
z"/>
<path fill="#BDDA15" opacity="1.000000" stroke="none" 
	d="
M102.836182,57.027599 
	C102.889313,37.663239 116.594894,22.548630 133.909225,18.720726 
	C154.089966,14.259101 176.060898,27.296198 180.883728,47.450897 
	C181.604675,50.463722 181.948456,53.638901 181.953979,56.739887 
	C182.023987,96.045425 182.000031,135.351151 182.000046,174.656815 
	C182.000046,176.806213 182.000046,178.955612 182.000046,181.999939 
	C179.581772,181.999939 177.504135,181.999954 175.426514,181.999954 
	C135.954300,181.999954 96.482071,182.007950 57.009853,181.996368 
	C38.828815,181.991028 22.210541,167.714767 18.967665,149.912842 
	C15.003813,128.153107 28.834024,108.728882 49.322113,103.409241 
	C51.834705,102.756851 54.607052,103.104881 58.166210,102.967728 
	C71.123917,102.964081 83.174622,103.021446 95.224792,102.964653 
	C97.470222,102.954071 99.713478,102.485062 101.957741,102.227623 
	C101.957741,102.227623 102.154060,102.115631 102.480774,101.713905 
	C102.817047,86.550652 102.826614,71.789124 102.836182,57.027599 
z"/>
<path fill="#BDDA15" opacity="1.000000" stroke="none" 
	d="
M70.794418,94.990875 
	C46.801723,103.268036 22.603350,86.730988 18.830381,63.742386 
	C14.785009,39.094044 36.129189,17.411589 58.070995,17.680119 
	C76.859718,17.910063 94.100510,33.370510 97.214233,51.070198 
	C100.502731,69.763313 88.004234,89.395004 70.794418,94.990875 
z"/>
</svg>
);
}
